import React, { useState } from 'react';
import { Box } from '@mui/material';
import CustomDrawer from '@ui-components/Drawer/CustomDrawer';
import CustomList from '@ui-components/List/CustomList';
import CustomIconButton from '@ui-components/IconButton/CustomIconButton';

// Images
import QlerLogo2 from '@assets/images/qler_logo_2.svg';
import Dashboard from '@assets/images/Dashboard.svg';
import Consults from '@assets/images/Consults.svg';
import Settings from '@assets/images/settings.svg';
import Logout from '@assets/images/log-out.svg';

// Css
import './layout.css';
import CustomListItemIcon from '@ui-components/List/CustomListItemIcon';
import CustomMenu from '@ui-components/Menu/CustomMenu';
import CustomMenuItem from '@ui-components/Menu/CustomMenuItem';
import CustomMenuList from '@ui-components/Menu/CustomMenuList';
import CustomTooltip from '@ui-components/ToolTip/CustomToolTip';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@auth/AuthProvider';
const SideNav: React.FC = () => {
  const [menu, setMenu] = useState<'consults' | 'dashboard'>('consults');
  console.log('menuItem', menu);
  const navigate = useNavigate();
  const tabChangeEvent = new Event('tabchange');
  const { logout } = useAuth();

  const handleLogout = () => {
    localStorage.clear();
    logout();
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <CustomDrawer
        anchor="left"
        hideBackdrop={true}
        variant="permanent"
        miniVariant
        miniWidth={80}
      >
        <Box className="sidebar-logo cursor-pointer height-100">
          <CustomIconButton
            id="logo"
            icon={<QlerLogo2 />}
            onClick={() => {
              localStorage.setItem('lastSelectedTabIndex', '0');
              document.dispatchEvent(tabChangeEvent);
              navigate('/provider/consults', { replace: true });
            }}
            className="sidebar-logo-icon"
          />
        </Box>
        {
          <Box className="sidebar-list">
            <CustomList>
              <Box className="pb-40">
                <CustomTooltip
                  id="nav-tooltip"
                  title="Consults"
                  placement="bottom-start"
                >
                  <Box
                    className={`sidebar-background ${
                      location.pathname === '/provider/consults' ||
                      location.pathname === '/provider/details'
                        ? 'active'
                        : ''
                    }`}
                  >
                    <CustomIconButton
                      id="iconConsults"
                      icon={<Consults />}
                      className="sidebar-icon-consults"
                      onClick={() => {
                        localStorage.setItem('lastSelectedTabIndex', '0');
                        document.dispatchEvent(tabChangeEvent);
                        setMenu('consults');
                        navigate('/provider/consults', { replace: true });
                      }}
                    />
                  </Box>
                </CustomTooltip>
              </Box>
              <Box className="pb-40">
                <CustomTooltip
                  id="nav-tooltip"
                  title="Dashboard"
                  placement="bottom-start"
                >
                  <Box
                    className={`sidebar-background ${
                      location.pathname === '/provider/metrics' ? 'active' : ''
                    }`}
                  >
                    <CustomIconButton
                      id="iconDashboard"
                      icon={<Dashboard />}
                      className="sidebar-icon"
                      onClick={() => {
                        setMenu('dashboard');
                        navigate('/provider/metrics');
                      }}
                    />
                  </Box>
                </CustomTooltip>
              </Box>
              <Box className="pb-40">
                <CustomTooltip
                  id="nav-tooltip"
                  title="Settings"
                  placement="bottom-start"
                >
                  <Box>
                    <CustomIconButton
                      onClick={handleMenuOpen}
                      id="iconSettings"
                      icon={<Settings />}
                      className="sidebar-icon"
                    />
                  </Box>
                </CustomTooltip>
              </Box>
            </CustomList>
          </Box>
        }
      </CustomDrawer>
      <Box className="sidenav-submenu">
        <CustomMenu
          id="sidenavsubmenu"
          anchorEl={anchorEl ?? document.body}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <CustomMenuList>
            <CustomMenuItem
              onClick={() => {
                handleLogout();
                handleMenuClose();
              }}
            >
              <CustomListItemIcon>{<Logout />}</CustomListItemIcon>
              Logout
            </CustomMenuItem>
          </CustomMenuList>
        </CustomMenu>
      </Box>
    </>
  );
};

export default SideNav;
